/**
 * Ruta stranice ovisno o načinu prikaza: canvas stranice žive pod grafičkim
 * prikazima, obične pod /pages. Na jednom mjestu jer isto mapiranje treba
 * dashboard (favoriti), prijava i ruter (početna stranica).
 */
export function pageRoute(id: number, layoutMode?: string | null): string {
  return layoutMode === "canvas" ? `/graphic-displays/${id}` : `/pages/${id}`;
}

/**
 * Sigurna interna ruta iz `?next=` parametra.
 *
 * Prihvaća samo relativne putanje ("/pages/5"); sve ostalo (apsolutni URL,
 * "//tudja-domena") vraća prazno da prijava ne posluži kao odskočna daska
 * prema vanjskoj stranici. Rute prijave odbijamo jer bi nakon prijave
 * vraćale natrag na prijavu — beskonačna petlja.
 */
export function safeNext(value: unknown): string {
  if (typeof value !== "string") return "";
  if (!value.startsWith("/") || value.startsWith("//")) return "";
  if (value === "/auth" || value.startsWith("/auth/")) return "";
  return value;
}
